<template>
  <el-dialog
    title="Add Agent"
    :visible.sync="show"
    @close="$emit('update:isVisible', false)"
    :close-on-click-modal="false"
  >
    <el-form @keyup.enter.native="handleSubmit">
      <el-form-item>
        <span slot="label">
          Agent Name
          <small>
            <el-tooltip
              class="modal-info"
              placement="right"
              effect="light"
              content="Used to identify the Agent throughout DataMaestro"
            >
              <i
                class="el-icon-info"
                style="position: relative; left: 2px; bottom: 4px"
              />
            </el-tooltip>
          </small>
        </span>
        <el-input
          v-model="$v.name.$model"
          :class="{ error: checkValid && $v.name.$invalid }"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="handleSubmit">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import AgentService from "../../services/AgentService";
import { mapState } from "vuex";
import Helper from "../../utilities/Helper";

/**
 * @vue-data {String} [name=""] - Name of the new environment
 * @vue-data {String} [adminHost=""] - Adminhost of the new environment
 * @vue-data {String} [error=""] - Error message from backend
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 */
export default {
  data() {
    return {
      name: null,
      checkValid: false,
      show: this.isVisible,
    };
  },
  props: {
    isVisible: Boolean,
  },
  watch: {
    isVisible(value) {
      if (value) this.resetModal(true);
      this.show = value;
    },
  },
  computed: {
    ...mapState(["organizationId"]),
  },
  methods: {
    handleError: Helper.handleError,
    trim: Helper.trim,
    /**
     * Resets the modal
     * @function
     */
    resetModal(isVisible) {
      if (isVisible) {
        this.name = null;
      }
      this.checkValid = false;
    },
    /**
     * Submits the new environment information
     * @async
     * @function
     */
    async handleSubmit() {
      this.checkValid = true;
      if (this.$v.name.$invalid) {
        return;
      }

      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        await AgentService.create({
          name: this.trim(this.name),
          organizationId: this.organizationId,
        });
        this.$message({
          type: "success",
          message: `Agent "${this.name}" added successfully`,
          duration: 5000,
          showClose: true,
        });
        this.checkValid = false;
        this.$emit("update:isVisible", false);
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
  },
  validations() {
    return {
      name: { required },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button {
  background-color: #7a7c80;
  color: white;
  border-color: white;
}
.cancel-button:focus {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button:hover {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
</style>
